// src/components/MaintenanceTaskModal.jsx
import { useState } from "react";
import { Button, Divider, Modal, CardContent, Stack } from "@mui/material";
import { LoadingButton } from '@mui/lab';

import MainCard from "components/MainCard";
import { useMaintenanceForm } from "./useMaintenanceForm";
import MaintenanceCommonForm from "./MaintenanceCommonForm";
import { useTranslation } from "react-i18next";
import PermissionButton from "components/PermissionButton";
import { PERMISSIONS } from "config/permissions";

const MaintenanceTaskModal = ({ id, onRefresh, type }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // 🚀 훅에 필수 정보와 성공 시 모달을 닫는 handleClose 전달
  const mForm = useMaintenanceForm({ id, onRefresh, type, handleCloseModal: handleClose });

  return (
    <>
      <PermissionButton
        permission={PERMISSIONS.MAINTENANCE_TASK_WRITE}
        className="pop_style_btn"
        type="button"
        onClick={handleOpen}
        style={{
          height: "35px",
          minHeight: "35px",
          marginLeft: "3px",
          marginRight: "3px"
        }}
      >
        <span>{t('message.common.btn.management.maintenance')}</span>

        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          style={{
            display: "block",
            flexShrink: 0
          }}
        >
          <path d="M7 17 17 7M8 7h9v9" />
        </svg>
      </PermissionButton>

      <Modal className="pop_box pop_box1 renew_pop_box maintenance_detail_renew_pop maintenance_datetime_alignment_pop" open={open} onClose={handleClose}>
        <MainCard modal darkTitle content={false} sx={{ width: 800 }}>
          <div className="modal-header">🚨 {t('message.common.btn.management.maintenance')}</div>

          <CardContent sx={{ maxHeight: "70vh", overflowY: "auto" }}>
            {/* 🚀 mForm.onFormSubmit 연결 */}
            <form onSubmit={mForm.handleSubmit(mForm.onFormSubmit)}>
              
              <MaintenanceCommonForm mForm={mForm} />

              <Divider />

              {/* 하단 풋터 단추 영역 */}
              <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ p: 2 }}>
                {((mForm.type && mForm.type === "modify" && mForm.maintenanceTask?.workingBgnAt) || (!mForm.maintenanceTask?.workingBgnAt)) && (
                  <LoadingButton variant="contained" size="small" color="primary" loading={mForm.fileLoading} type="submit">
                    {(mForm.type === "modify" && mForm.maintenanceTask?.workingBgnAt) ? t('message.common.btn.modify') : t('message.common.btn.write')}
                  </LoadingButton>
                )}
                <Button variant="contained" className="maintenance_detail_cancel" onClick={handleClose}>{t('message.common.btn.cancel')}</Button>
              </Stack>

            </form>
          </CardContent>
        </MainCard>
      </Modal>
    </>
  );
};

export default MaintenanceTaskModal;